import Grid from '@mui/material/Grid';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';

export default function ClientDashboardSkeleton() {
  return (
    <Layout>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Skeleton variant="rectangular" animation="wave" height={240} />
        </Grid>
      </Grid>
    </Layout>
  );
}
